/**
 * Bundle add-on.
 *
 * Horizon's add-to-cart posts a single variant, so the add-on has to go in as
 * its own line. We intercept the add-to-cart click in the capture phase, post
 * the add-on first and wait for it, then let Horizon's own handler run — by the
 * time it refreshes the cart sections, both lines are already in the basket.
 * Doing it the other way round races the refresh and the add-on flickers in.
 *
 * If the add-on request fails, the main add still proceeds. A missing extra is
 * a far better outcome than a dead button.
 */
class TbpsBundleAddon extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.variantId = this.dataset.variantId;
    if (!this.checkbox || !this.variantId) return;

    this.form = this.closest('.product-details, product-form-component, form') || document;
    this.button = this.#findAddToCartButton();
    if (!this.button) return;

    this.busy = false;
    this.button.addEventListener('click', this.#onAddToCart, { capture: true });
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#onAddToCart, { capture: true });
  }

  #findAddToCartButton() {
    const root = this.closest('.product-details') || document;
    return root.querySelector(
      'add-to-cart-component button, .product-form-buttons button[type="submit"], button[name="add"]'
    );
  }

  #onAddToCart = async (event) => {
    if (!this.checkbox.checked || this.busy) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.busy = true;

    try {
      await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1 }] }),
      });
    } catch (error) {
      console.warn('Bundle add-on could not be added:', error);
    }

    // Untick so a second add-to-cart doesn't silently add it again.
    this.checkbox.checked = false;
    this.busy = false;
    this.button.click();
  };
}

if (!customElements.get('tbps-bundle-addon')) {
  customElements.define('tbps-bundle-addon', TbpsBundleAddon);
}
